'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  events: {
    addEvent: 'Add event',
    allEvents: 'All the events',
    audiencebox: {
      name: 'Audience'
    },
    authorFilter: {
      createdBy: 'Created by',
      all: 'All',
      me: 'Myself',
      other: 'Others'
    },
    categoriesBox: {
      choose: 'Categories'
    },
    calendarBox: {
      calendars: 'Calenders'
    },
    createdBy: 'Created by %{author}',
    createEvent: 'Create Event',
    dateCount: 'One date |||| %{smart_count} dates',
    dateFilter: {
      future: 'Future events',
      past: 'Past events',
      all: 'All the events'
    },
    empty: 'No Event found.',
    facebookBox: {
      add: 'Add link to existing Facebook event:',
      name: 'Facebook event'
    },
    form: {
      calendar: {
        applyToAllDates: 'Apply to all dates',
        backToDates: 'Add more dates',
        cancel: 'Cancel',
        chooseMode: 'Choose mode for the event',
        dateTime: 'Date and time',
        modeMultiple: 'On specific dates',
        modeRange: 'Everyday',
        modeSingle: 'Only one date',
        otherDates: 'Another |||| %{smart_count} other dates',
        save: 'OK',
        selectDate: 'Select a date to choose the time.',
        selectHours: 'Select the time',
        selectedDate: '%{smart_count} selected date |||| %{smart_count} selected dates',
        time: {
          add: 'Add a duration',
          endTime: 'Indetermined end time',
          fillStartTime: 'Fill in the start time',
          from: 'From',
          invalidFormat: 'Invalid format.',
          startTime: 'Start time',
          to: 'to'
        },
        toggleMultipleTimes: 'This event takes place several times in the same day'
      },
      confirmSave: 'Do you want to save the changes\xA0?',
      dontSave: 'Do not save',
      importedFrom: 'Imported from',
      save: 'Save',
      status: {
        title: 'Status:',
        draft: 'Draft',
        pending: 'Pending',
        published: 'Published'
      },
      required: 'required'
    },
    groupsBox: {
      add: 'Add groups:',
      groupAlreadyExists: 'This group already exists',
      help: 'Type something to search',
      noResults: 'No results.',
      title: 'Groups',
      typeSome: 'Type to search...'
    },
    integrationJsBox: {
      hide: 'Hide',
      markupLabel: 'HTML tags',
      replacements: 'Replacements available : {foreach $events}{/foreach}', // TODO
      show: 'Show',
      styleLabel: 'Styling (CSS)',
      title: 'Javascript integration '
    },
    loading: 'Loading...',
    noResults: 'No results.',
    next: 'Next page',
    previous: 'Previous page',
    priceBox: {
      addPrice: 'Add a price',
      donation: 'Donation',
      fixed: 'Payment required',
      free: 'Free',
      specifyProtocol: 'Always specify http:// or https:// .',
      title: 'Price',
      ticketingWebsite: 'Ticketing website'
    },
    sortDirection: {
      asc: 'Ascending',
      desc: 'Descending'
    },
    sortOrder: {
      created_at: 'Created at',
      start_date: 'Start date',
      title: 'Event title',
      updated_at: 'Updated at'
    },
    status: {
      declined: 'Declined',
      deleted: 'Deleted',
      draft: 'Draft',
      partially_published: 'Partially published',
      pending: 'Pending',
      published: 'Published'
    },
    statusFilter: {
      all: 'all',
      published: 'published',
      partiallyPublished: 'partially published',
      pending: 'pending',
      declined: 'declined',
      draft: 'draft',
      deleted: 'deleted'
    },
    tagBox: {
      add: 'Add the tags :',
      createTag: 'Create the tag',
      help: 'Examples : cinema, astrobiology, post-rock',
      select: 'Select...',
      title: 'Tags',
      tagAlreadyExists: 'This tag already exists',
      typeSome: 'Type to start search...'
    },
    termsBox: {
      add: 'Add the %{key} :',
      help: 'Type something to search'
    },
    title: 'Events',
    titleBox: {
      help: 'Event title'
    },
    to: 'to',
    total: '%{smart_count} events sorted by |||| %{smart_count} events sorted by',
    typeBox: {
      name: 'Event type',
      noResults: 'No results.',
      choose: 'Choose event type :',
      help: 'Examples: Conference, Workshop, Exhibition'
    },
    updatedAt: 'Modified at %{date}',
    videoBox: {
      enterAddress: 'Enter the address of a YouTube or Vimeo video:',
      video: 'Video'
    },
    venueBox: {
      chooseRegion: 'Select a region',
      region: 'Region',
      venueByDates: 'Different venue by date'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/events.js
// module id = 2283
// module chunks = 0